/* eslint-disable */
export default {
  searchPlaceholder: 'Ricerca...',
  refresh: 'Aggiorna',
} as const;

// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
// @key: @#@"refresh"@#@ @source: @#@"Refresh"@#@
